export default __webpack_public_path__ + "d38c0a2e719e4689e5c3c6dbea6252e5.png";